import { Embroidery, StateObj } from 'src/types'
import {
  notThumbEmbroidery,
  liningEmbroidery,
  thumbEmbroidery,
  bottomRightOfBeltEmbroidery,
  sideOfLabelEmbroidery
  // circleHollowOutEmbroidery
} from 'src/features/yellStory/drawer/common/back/embroidery'
import { ysrDirectLabel } from '../../labels/yellStory'

const liningEmbroideryObject = {
  first: {
    x: 110,
    y: -75,
    position: 'leatherLiningFirst'
  },
  second: {
    x: 115,
    y: -30,
    position: 'leatherLiningSecond'
  }
}

export const liningEmbroideryDrawer = (
  ctx: CanvasRenderingContext2D,
  embroideries: Embroidery[],
  step: 'first' | 'second',
  fontSize?: string
): void => {
  const isEmbroideryOfLining = embroideries?.some((x) => x.position.value === liningEmbroideryObject[step].position)
  if (isEmbroideryOfLining) {
    liningEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === liningEmbroideryObject[step].position),
      liningEmbroideryObject[step].x,
      liningEmbroideryObject[step].y,
      fontSize
    )
  }
}

export const liningDirectLogo2EmbroideryDrawer = (
  ctx: CanvasRenderingContext2D,
  ysrDirectLogo2Position: StateObj,
  ysrDirectLogo2Color: StateObj
): void => {
  const isEmbroideryOfLining = ysrDirectLogo2Position.value === 'leatherLiningFirst'
  if (isEmbroideryOfLining) {
    ctx.lineWidth = 0.5
    ctx.strokeStyle = ysrDirectLogo2Color.color // '#eeeeee'
    ctx.fillStyle = ysrDirectLogo2Color.color
    ctx.beginPath()
    ctx.font = '22px serif'
    ctx.fillText(`" Yell-story "`, 335, 420)
    ctx.strokeText(`" Yell-story "`, 335, 420)
    ctx.font = '14px serif'
    ctx.fillText(`since2017`, 370, 440)
    ctx.strokeText(`since2017`, 370, 440)
    ctx.stroke()
    ctx.closePath()
  }
}

export const middleFingerDirectLogo2EmbroideryDrawer = (
  ctx: CanvasRenderingContext2D,
  ysrDirectLogo2Position: StateObj,
  ysrDirectLogo2Color: StateObj
): void => {
  const isEmbroideryOfLining = ysrDirectLogo2Position.value === 'middleFinger'
  if (isEmbroideryOfLining) {
    ctx.lineWidth = 0.5
    ctx.strokeStyle = ysrDirectLogo2Color.color // '#eeeeee'
    ctx.fillStyle = ysrDirectLogo2Color.color
    ctx.save()
    ctx.rotate((93 * Math.PI) / 180)
    ctx.beginPath()
    ctx.font = '22px serif'
    ctx.fillText(`" Yell-story "`, 135, -355)
    ctx.strokeText(`" Yell-story "`, 135, -355)
    ctx.font = '14px serif'
    ctx.fillText(`since2017`, 165, -335)
    ctx.strokeText(`since2017`, 165, -335)
    ctx.stroke()
    ctx.closePath()
    ctx.restore()
  }
}

export const ringFingerDirectLogo2EmbroideryDrawer = (
  ctx: CanvasRenderingContext2D,
  ysrDirectLogo2Position: StateObj,
  ysrDirectLogo2Color: StateObj
): void => {
  const isEmbroideryOfLining = ysrDirectLogo2Position.value === 'ringFinger'
  if (isEmbroideryOfLining) {
    ctx.lineWidth = 0.5
    ctx.strokeStyle = ysrDirectLogo2Color.color // '#eeeeee'
    ctx.fillStyle = ysrDirectLogo2Color.color
    ctx.save()
    ctx.rotate((85 * Math.PI) / 180)
    ctx.beginPath()
    ctx.font = '22px serif'
    ctx.fillText(`" Yell-story "`, 225, -250)
    ctx.strokeText(`" Yell-story "`, 225, -250)
    ctx.font = '14px serif'
    ctx.fillText(`since2017`, 255, -230)
    ctx.strokeText(`since2017`, 255, -230)
    ctx.stroke()
    ctx.closePath()
    ctx.restore()
  }
}

export const thumbEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[]): void => {
  const isEmbroideryDraw = embroideries?.some((x) => x.position.value === 'thumbFinger')
  if (isEmbroideryDraw)
    thumbEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === 'thumbFinger'),
      -115,
      30,
      -15
    )
}

const nonThumbEmbroideryObject = {
  middleFinger: {
    x: -140,
    y: -190,
    numerator: 5
  },
  ringFinger: {
    x: -60,
    y: -80,
    numerator: -5
  },
  childFinger: {
    x: -70,
    y: -45,
    numerator: -2
  }
}

export const nonThumbEmbroideryDrawer = (
  ctx: CanvasRenderingContext2D,
  fingerType: 'middleFinger' | 'ringFinger' | 'childFinger',
  embroideries: Embroidery[]
): void => {
  const isEmbroideryDraw = embroideries?.some((x) => x.position.value === fingerType)
  if (isEmbroideryDraw) {
    notThumbEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === fingerType),
      nonThumbEmbroideryObject[fingerType].x,
      nonThumbEmbroideryObject[fingerType].y,
      nonThumbEmbroideryObject[fingerType].numerator
    )
  }
}

export const bottomRightOfBeltEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[], x: number, y: number): void => {
  const filterFunction = (x: Embroidery) => x.position.value === 'belt'
  const isEmbroideryOfLining = embroideries?.some(filterFunction)
  if (isEmbroideryOfLining) {
    bottomRightOfBeltEmbroidery(ctx, embroideries?.find(filterFunction), x, y)
  }
}

export const sideOfLabelEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[], x: number, y: number): void => {
  const filterFunction = (x: Embroidery) => x.position.value === 'sideOfLabel'
  const isEmbroideryOfLining = embroideries?.some(filterFunction)
  if (isEmbroideryOfLining) {
    sideOfLabelEmbroidery(ctx, embroideries?.find(filterFunction), x, y)
  }
}

export const directLogo1EmbroideryBandDrawer = (
  ctx: CanvasRenderingContext2D,
  ysrDirectLogo1Position: StateObj,
  ysrDirectLogo1MainColor: StateObj,
  ysrDirectLogo1EdgeColor: StateObj,
  band: StateObj
): void => {
  const isDrawOnBand = ysrDirectLogo1Position.value === 'band'
  if (isDrawOnBand) {
    ysrDirectLabel(ctx, ysrDirectLogo1MainColor, ysrDirectLogo1EdgeColor, band, 0, 0)
  }
}

export const directLogo1EmbroideryMiddleFingerDrawer = (
  ctx: CanvasRenderingContext2D,
  ysrDirectLogo1Position: StateObj,
  ysrDirectLogo1MainColor: StateObj,
  ysrDirectLogo1EdgeColor: StateObj,
  band: StateObj
): void => {
  const isDrawOnBand = ysrDirectLogo1Position.value === 'middleFinger'
  if (isDrawOnBand) {
    ctx.save()
    ctx.rotate((95 * Math.PI) / 180)
    ctx.scale(0.8, 0.8)
    ctx.beginPath()
    ysrDirectLabel(ctx, ysrDirectLogo1MainColor, ysrDirectLogo1EdgeColor, band, -185, -990)
    ctx.closePath()
    ctx.restore()
  }
}

export const directLogo1EmbroideryRingFingerDrawer = (
  ctx: CanvasRenderingContext2D,
  ysrDirectLogo1Position: StateObj,
  ysrDirectLogo1MainColor: StateObj,
  ysrDirectLogo1EdgeColor: StateObj,
  band: StateObj
): void => {
  const isDrawOnBand = ysrDirectLogo1Position.value === 'ringFinger'
  if (isDrawOnBand) {
    ctx.save()
    ctx.rotate((87 * Math.PI) / 180)
    ctx.scale(0.8, 0.8)
    ctx.beginPath()
    ysrDirectLabel(ctx, ysrDirectLogo1MainColor, ysrDirectLogo1EdgeColor, band, -70, -860)
    ctx.closePath()
    ctx.restore()
  }
}
